import request from './adminRequest'

export const openJobApi = {
  listUser (params) {
    return request.get('/openjob/listUser', { params: params })
  },
  getUser (params) {
    return request.get('/openjob/getUser', { params: params })
  },
  deleteJobSurvey (uid) {
    return request.delete('/openjob/deleteJobSurvey/' + uid)
  },
  updateUser (data) {
    return request.post('/openjob/updateUser', data)
  },
  setFree (data) {
    return request.post('/openjob/setFree', data)
  },
  getJobUserAutoApply (uid) {
    return request.get('/openjob/getJobUserAutoApply', { params: { uid } })
  },
  updateEmailForward (data) {
    return request.post('/openjob/updateEmailForward', data)
  },
}
export default openJobApi
